import { Rating, styled, Tooltip } from '@mui/material'
import { ReactElement, useEffect, useState } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import {
  MdOutlineSentimentDissatisfied,
  MdOutlineSentimentNeutral,
  MdOutlineSentimentSatisfied,
  MdOutlineSentimentVeryDissatisfied,
  MdOutlineSentimentVerySatisfied,
} from 'react-icons/md'

interface CustomRatingProps {
  value: number | null | undefined
  setValue: UseFormSetValue<any>
}

const customIcons: {
  [index: string]: {
    icon: ReactElement
    label: string
  }
} = {
  1: {
    icon: <MdOutlineSentimentVeryDissatisfied color="error" />,
    label: 'Muito insatisfeito',
  },
  2: {
    icon: <MdOutlineSentimentDissatisfied color="error" />,
    label: 'Insatisfeito',
  },
  3: {
    icon: <MdOutlineSentimentNeutral color="warning" />,
    label: 'Neutro',
  },
  4: {
    icon: <MdOutlineSentimentSatisfied color="success" />,
    label: 'Satisfeito',
  },
  5: {
    icon: <MdOutlineSentimentVerySatisfied color="success" />,
    label: 'Muito satisfeito',
  },
}

const StyledRating = styled(Rating)(({ theme }) => ({
  '& .MuiRating-iconEmpty .MuiSvgIcon-root': {
    color: theme.palette.action.disabled,
  },
  '& .MuiRating-iconEmpty .MuiSvgIcon-root, .MuiRating-iconHover .MuiSvgIcon-root, .MuiRating-iconFilled .MuiSvgIcon-root':
    {
      fontSize: 32,
    },
}))

function CustomRating(props: CustomRatingProps) {
  const { value, setValue } = props
  const [rate, setRate] = useState<number | null | undefined>(value)
  const [isTooltipVisible, setIsTooltipVisible] = useState<{
    open: boolean
    value: number | null
  }>({
    open: false,
    value: 1,
  })

  useEffect(() => {
    if (rate) setValue('rate', rate)
  }, [rate, setValue])

  function IconContainer(props: any) {
    const { value, ...other } = props
    return <span {...other}>{customIcons[value].icon}</span>
  }

  return (
    <Tooltip title={customIcons[isTooltipVisible.value || 1].label}>
      <StyledRating
        value={rate || 0}
        name="rate"
        onChange={(_, newValue) => {
          setValue('rate', newValue)
          setRate(newValue)
        }}
        size="large"
        IconContainerComponent={IconContainer}
        highlightSelectedOnly
        onChangeActive={(_, value) => {
          if (value !== -1) {
            setIsTooltipVisible({
              open: true,
              value,
            })
          }
        }}
        sx={{
          margin: '0 auto',

          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      />
    </Tooltip>
  )
}

export default CustomRating
